import { render, staticRenderFns } from "./groupGood.vue?vue&type=template&id=4c8f2aa2&"
import script from "./groupGood.vue?vue&type=script&lang=js&"
export * from "./groupGood.vue?vue&type=script&lang=js&"
import style0 from "./groupGood.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports